export default "__VITE_ASSET__BCzyuJKV__"